import React, { createContext, useContext, useState } from 'react';

type AppointmentModalContextType = {
  open: (id?: string, queryString?: string, phoneNumber?: string) => void;
  close: () => void;
  isOpenModal: boolean;
  itemId: string;
  queryString?: string;
  phoneNumber?: string;
  itemName?: string;
  setItemName: (name: string) => void;
  officeHoursSectionId?: {
    uid?: string;
    toggleOpen?: (open?: boolean) => void;
  } | null;
  setOfficeHoursSectionId?: ({
    uid,
    toggleOpen,
  }: {
    uid: string;
    toggleOpen: (open?: boolean) => void;
  }) => void;
};

const AppointmentModalContext = createContext<AppointmentModalContextType>({
  open: () => {},
  close: () => {},
  isOpenModal: false,
  itemId: '',
  queryString: '',
  itemName: '',
  setItemName: () => {},
  officeHoursSectionId: null,
  setOfficeHoursSectionId: () => {},
});

export const useAppointmentModal = () => useContext(AppointmentModalContext);

export const AppointmentModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [itemId, setItemId] = useState('');
  const [queryString, setQueryString] = useState('');
  const [itemName, setItemName] = useState<string>('');
  const [officeHoursSectionId, setOfficeHoursSectionId] = useState<{
    uid?: string;
    toggleOpen?: (open?: boolean) => void;
  } | null>(null);

  const open = (id: string | undefined, queryString?: string, phone?: string) => {
    setIsOpenModal(true);
    setItemId(id ?? '');
    setPhoneNumber(phone || '');
    if (queryString || queryString !== '') {
      setQueryString(queryString || '');
    } else {
      setQueryString('');
    }
  };
  const close = () => setIsOpenModal(false);

  return (
    <AppointmentModalContext.Provider
      value={{
        open,
        close,
        isOpenModal,
        itemId,
        queryString,
        setItemName,
        itemName,
        officeHoursSectionId,
        setOfficeHoursSectionId,
        phoneNumber,
      }}
    >
      {children}
    </AppointmentModalContext.Provider>
  );
};
